// gem.js: v7 HAUTE COSMOS world. PRESSURE (slot ignite, mode 'ignite') and YOURS (slot brand, mode 'brand'): live diamond on velvet / the brand's own gem on pearl silk.
// STUB: re-exports the v5 nebula world so the site keeps working until the gem agent swaps in './gem/world.js'.
// Owner: the gem agent (see web/src/worlds/V7.md).
export { create } from './nebula.js';
